var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var DistrictSearch = require("components/org/roster/DistrictSearch");
var Glyphicon = require("components/utility/icons/Glyphicon");

var DisplayToggleControl = require("components/utility/DisplayToggleControl");

import ReactSelect from "react-select";

import { Link } from "react-router-dom";


class CleverLinkSections extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		
		this.state = { sections: {}, currentSchool: props.schools[0].clever_id,
		 selectedTerm: {}, terms: {}, selectedSubject: {}, subjects: {}, gradeLevels: {}, selectedGradeLevel: {}}
	}

	onSelectTerm(school, selected) {
		var selectedTerm = this.state.selectedTerm
		
		if (selected) {
			selectedTerm[school.clever_id] = selected
		} else {
			delete selectedTerm[school.clever_id]
		}
		this.setState({selectedTerm})
	}

	renderTermWarning(school) {
		if (this.state.terms[school.clever_id].length > 0) {
			return "Warning: This school uses multiple terms!"
		}
		return ""
	}

	renderTermOptions(school) {
		var options = _.map(this.state.terms[school.clever_id], (subject) => {
			return {value: subject, label: subject}
		})
		return <ReactSelect name="subject" value={ this.state.selectedTerm[school.clever_id] }
						options={ options } onChange={ this.onSelectTerm.bind(this, school) } placeholder="Select Term"/>
	}

	onSelectSubject(school, selected) {
		var selectedSubject = this.state.selectedSubject
		
		if (selected) {
			selectedSubject[school.clever_id] = selected
		} else {
			delete selectedSubject[school.clever_id]
		}
		
		this.setState({selectedSubject})
	}

	renderSubjectOptions(school) {

		var options = _.map(this.state.subjects[school.clever_id], (subject) => {
			return {value: subject, label: subject}
		})
		return <ReactSelect name="subject" value={ this.state.selectedSubject[school.clever_id] }
						options={ options } onChange={ this.onSelectSubject.bind(this, school) } placeholder="Select Subject"/>
	}

	onSelectGrade(school, selected) {
		var selectedGradeLevel = this.state.selectedGradeLevel
		if (selected) {
			selectedGradeLevel[school.clever_id] = selected
		} else {
			delete selectedGradeLevel[school.clever_id]
		}
		
		this.setState({selectedGradeLevel})
	}

	renderGradeOptions(school) {

		var options = _.map(this.state.gradeLevels[school.clever_id], (grade) => {
			return {value: grade, label: grade}
		})
		return <ReactSelect name="grade" value={ this.state.selectedGradeLevel[school.clever_id] }
						options={ options } onChange={ this.onSelectGrade.bind(this, school) } placeholder="Select Grade"/>
	}

	getFilteredSections(school) {
		if (school.clever_id in this.state.selectedTerm) {
			var filteredSections = _.values( _.pick(this.state.sections[school.clever_id], (section) => {
				return section.term && section.term.name == this.state.selectedTerm[school.clever_id].value
			}))
		} else {
			var filteredSections = this.state.sections[school.clever_id]
		}

		if (school.clever_id in this.state.selectedSubject) {
			var filteredSections = _.values( _.pick(filteredSections, (section) => {
				return section.subject == this.state.selectedSubject[school.clever_id].value
			}))
		}

		if (school.clever_id in this.state.selectedGradeLevel) {
			var filteredSections = _.values( _.pick(filteredSections, (section) => {
				return section.grade == this.state.selectedGradeLevel[school.clever_id].value
			}))
		}
		return filteredSections
	}

	renderSelectedSections() {
		const school = _.values(_.pick(this.props.schools, (school) => school.clever_id == this.state.currentSchool))[0] 
		var sections = _.values(_.pick( this.state.sections[school.clever_id], (section) => {
			return section.selected
		}))

		if (sections.length > 0) {

			var sectionDict = {}
			_.each(sections, (section) => {
				var key = section.name + section.subject
				if (!sectionDict[key]) {
					sectionDict[key] = {name: section.name, subject: section.subject}
				}
			})

			var rows = _.map(sectionDict, (section, s) => {

				var termDups = []
				var terms = _.map( _.sortBy (_.values(_.pick( this.state.sections[school.clever_id], (otherSection) => {
					return section.name == otherSection.name && otherSection.term != undefined
				})), otherSection => otherSection.term.start_date), (relatedSection, rs) => {
					termDups.push(relatedSection.term.name)
					if (relatedSection.selected) {
						return <ul key={rs}><b>{relatedSection.term.name + " | " + relatedSection.term.start_date + " | "}</b> <a onClick={this.toggleSectionSelect.bind(this, school, relatedSection)}>exclude</a></ul>
					} else {
						return <ul key={rs}>{relatedSection.term.name + " | " + relatedSection.term.start_date + " | " } <a onClick={this.toggleSectionSelect.bind(this, school, relatedSection)}>select</a> </ul>
					}
				})

				if (_.uniq(termDups).length != termDups.length) {
					var color = "danger"
				} else if (termDups.length > 1) {
					var color = "warning" 
				} else {
					var color = "info"
				}

				return (
					<tr key={s} className={color}>
						<td>
							{ section.name } - {section.grade}
						</td>
						<td>
							{ section.subject }
						</td>
						<td>
							{terms}
						</td>
					</tr>
				)
			})

			var selectedTable = (
				<table className="table table-dark" style={{"backgroundColor": "#eee"}}>
					<thead>
						<tr>
							<th>
								Name
							</th>
							<th>
								Subject
							</th>
							<th>
								Terms
							</th>
						</tr>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
			)
		}
		if (sections.length > 0) {
			var deselectAll = (<a onClick={this.toggleAll.bind(this, school)}>| deselect all</a>)
		}
		return (
			<div>
				<b>{ sections.length + " Section(s) selected" }</b> {deselectAll}
				{ selectedTable }
				<div className="row">
					<div className="col-sm-4">
						<table className="table">
							<tbody>
								<tr>
									<td className="info">
									</td>
									<td>
										Sections with single term <br/>(No additional steps)
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div className="col-sm-4">
						<table className="table">
							<tbody>
								<tr>
									<td className="warning">
									</td>
									<td>
										Sections with multiple terms <br/>(Select all that apply)
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div className="col-sm-4">
						<table className="table">
							<tbody>
								<tr>
									<td className="danger">
									</td>
									<td>
										Sections with duplicate names <br/>(Clarify Clever ID with admin)
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		)
	}

	renderSections() {
		const school = _.values(_.pick(this.props.schools, (school) => school.clever_id == this.state.currentSchool))[0]
		
		
		var rows = _.map(this.getFilteredSections(school), (section, i) => {

			return (
				<tr key={i}>
					<td>
						{ section.name } | { section.clever_id.slice(section.clever_id.length-4,section.clever_id.length) }
					</td>
					<td>
						{ section.grade }
					</td>
					<td>
						{ section.term != null ? (section.term.name + " | " + section.term.start_date + " | " + section.term.end_date) : "" }
					</td>
					<td>
						{ section.subject }
					</td>
					<td>
						{ section.teachers.length }
					</td>
					<td>
						{ section.student_count }<br/>
						{ `${section.link_suggestion_count} link suggestions`}
					</td>
					<td>
						{ section.match ? "yes" : "no" }
					</td>
					<td>
						{ section.student_list_id ? "yes" : "no" }
					</td>
					<td>
						<input type="radio" checked={section.selected} onClick={this.toggleSectionSelect.bind(this, school, section)}></input>
					</td>
					
				</tr>
			)
		})
		if (this.state.sectionLoading) {
			var loader = <Spinner placeholder={ true } scale={ 1.7 } />
		}
		if (school.clever_id in this.state.terms && this.state.terms[school.clever_id].length > 0) {
			var termOptions = this.renderTermOptions(school)
			var termWarning = this.renderTermWarning(school)
		}
		if (school.clever_id in this.state.subjects && this.state.subjects[school.clever_id].length > 0) {
			var subjectOptions = this.renderSubjectOptions(school)
		}
		if (school.clever_id in this.state.gradeLevels && this.state.gradeLevels[school.clever_id].length > 0) {
			var gradeOptions = this.renderGradeOptions(school)
		}
		if (this.state.sectionLoading) {
			var loader = <Spinner placeholder={ true } scale={ 1.7 } />
		}
		return (
			<div>
				{ this.renderSelectedSections() }
				{ termWarning }
				{ termOptions }
				{ subjectOptions }
				{ gradeOptions }
				{ loader }
				<table className="table">
					<thead>
						<tr>
							<th>
								Name
							</th>
							<th>
								Grade
							</th>
							<th>
								Term
							</th>
							<th>
								Subject
							</th>
							<th>
								Teachers
							</th>
							<th>
								Students
							</th>
							<th>
								Pre-sync
							</th>
							<th>
								Provisioned
							</th>
							<th>
								Selected
							</th>
						</tr>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
			</div>
		)

	}
	
	onOptionChange(currentSchool) {
		this.setState({ currentSchool }, this.loadSections(currentSchool))
	}

	renderOptions() {
		var toggleOptions = _.map(this.props.schools, (school) => {
			return { key: school.clever_id, text: school.name }
		})

		return (
			<DisplayToggleControl options={ toggleOptions }
				onChange={ this.onOptionChange }
				activeOptionKey={ this.state.currentSchool } />
		);
	}

	render() {

		if (this.state.sections) {
			var view = this.renderSections()
		} else {
			var view = <Spinner placeholder={ true } scale={ 0.5 } />
		}
		

		return (
			<div className="CleverLinkSections">
				<h2>5 - Link Sections</h2>
				{ this.renderOptions() }
				{ view }
			</div>
		);
	}

	componentDidMount() {
		if (this.props.schools.length > 0) {
			this.loadSections(this.props.schools[0].clever_id)
		}
	}

	loadSections(school_id) {
		if (!(school_id in this.state.sections)) {
			this.setState({sectionLoading: true})
			var params = {page: 1, per_page: 20, clever_school_id: school_id, embed:"clever_section.teachers,clever_section.student_count"}
			this.loadPaginatedSections(params)
		}
	}

	extractTerms(clever_school_id, sections) {
		var terms = this.state.terms

		if (!(clever_school_id in terms)) {
			terms[clever_school_id] = []
		}

		_.each(sections, (section) => {
			if (section.term && !terms[clever_school_id].includes(section.term.name)) {
				terms[clever_school_id].push(section.term.name)
			}
		})
		console.log("TERMS", clever_school_id, sections, terms)
		this.setState({ terms })
	}

	extractSubjects(clever_school_id, sections) {
		var subjects = this.state.subjects

		if (!(clever_school_id in subjects)) {
			subjects[clever_school_id] = []
		}

		_.each(sections, (section) => {
			if (!subjects[clever_school_id].includes(section.subject)) {
				subjects[clever_school_id].push(section.subject)
			}
		})
		console.log("SUBJECTS", clever_school_id, sections, subjects)
		this.setState({ subjects })
	}

	extractGradeLevels(clever_school_id, sections) {
		var gradeLevels = this.state.gradeLevels

		if (!(clever_school_id in gradeLevels)) {
			gradeLevels[clever_school_id] = []
		}

		_.each(sections, (section) => {
			if (!gradeLevels[clever_school_id].includes(section.grade)) {
				gradeLevels[clever_school_id].push(section.grade)
			}
		})
		gradeLevels[clever_school_id] = gradeLevels[clever_school_id].sort()
		this.setState({ gradeLevels })
	}

	loadPaginatedSections(params) {
		CurrentUser.api().getCleverSections(params, $wr.apiHandler((response) => {
			var sections = this.state.sections
			if (response.clever_sections.length > 0) {
				const clever_school_id = params["clever_school_id"]
				if (clever_school_id in sections) {
					sections[clever_school_id] = sections[clever_school_id].concat(response.clever_sections)
				} else {
					sections[clever_school_id] = response.clever_sections
				}
				this.setState({ sections: sections });
				this.extractTerms(clever_school_id, response.clever_sections)
				this.extractSubjects(clever_school_id, response.clever_sections)
				this.extractGradeLevels(clever_school_id, response.clever_sections)
				params["page"] += 1
				this.loadPaginatedSections(params)
			} else {
				this.setState({sectionLoading: false})
			}
		}));
	}
	toggleAll(school) {
		console.log("TOGGLED ALL")

		var confirm = window.confirm("Are you sure you'd like to deselect all sections?");
		if (confirm == true) {
			var selectedSections = _.values( _.pick(this.state.sections[school.clever_id], (section) => {
				return section.selected
			}))

			_.each(selectedSections, (section) => {
				this.toggleSectionSelect(school, section)
			})
		}
	}

	toggleSectionSelect(school, section) {
		CurrentUser.api().patchCleverSection(section.id, {clever_section: {selected: !section.selected}}, $wr.apiHandler((response) => {
			var sections = this.state.sections
			var index = 0
			_.some(sections[school.clever_id], (csection, s) => {
				if (section.id == csection.id) {
					index = s
					return true
				}
			})
			sections[school.clever_id][index].selected = !section.selected
			this.setState({ sections }) 
		}));
	}
};

CleverLinkSections.propTypes = PageStrictPropTypes({
});

module.exports = CleverLinkSections;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverLinkSections.js